import { render, staticRenderFns } from "./CompoundTable.vue?vue&type=template&id=297c2672&"
import script from "./CompoundTable.vue?vue&type=script&lang=js&"
export * from "./CompoundTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports